import { cn } from '@/utils'
import type { ReactNode } from 'react'

interface BlockProps {
  title?: ReactNode
  children?: ReactNode
  className?: string
  subTitle?: ReactNode
  contentClassName?: string
}

export const Block = ({ title, children, className, subTitle, contentClassName }: BlockProps) => {
  return (
    <div className={cn('relative my-14', className)}>
      {!!title && (
        <div className="rounded-t	left-0 relative px-3 text-sm py-1 bg-primary text-white w-fit">{title}

        </div>
      )}
      {!!subTitle && <div className="text-sm text-gray-400 absolute top-1 left-[120px] w-fit">{subTitle}</div>}
      <div className={cn('bg-neutral-100 ', contentClassName)}>
        {children}
      </div>
    </div>
  )
}
